import { TranslatedText } from "../core/TranslatedText";

export interface WorkflowMap {
    id: number;
    translations: TranslatedText[];
}

export function isQuoteStep(step: WorkflowMap | undefined) {
    return step && step.id == 1;
}

export function isOrderStep(step: WorkflowMap | undefined) {
    return step && step.id == 2;
}

export function isClosedStep(step: WorkflowMap | undefined) {
    return step && step.id == 15; 
}